import { IconProps } from "./types";

// Native aspect ratio of the design spec's SVG — non-square, so `size` maps
// to width and height is derived to avoid distorting the glyph.
const VIEWBOX_WIDTH = 10;
const VIEWBOX_HEIGHT = 15;

/**
 * Solid up arrow used by Order Details' Pickup row icon (see `StopIcon`).
 * Deliberately its own glyph rather than a reuse of `ArrowUpIcon` (the
 * map's PickupMarker arrow) — different shape, different consumer.
 */
export const PickupArrowIcon = ({ size = VIEWBOX_WIDTH, color = "currentColor", className }: IconProps) => {
  const height = size * (VIEWBOX_HEIGHT / VIEWBOX_WIDTH);

  return (
    <svg
      width={size}
      height={height}
      viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.729 1.817a.9.9 0 0 0-.628.257L.26 5.867a.86.86 0 0 0 0 1.232.9.9 0 0 0 1.254-.002l2.328-2.3v7.058a.88.88 0 0 0 .887.872.88.88 0 0 0 .886-.872V4.798l2.332 2.299a.897.897 0 0 0 1.254.002.86.86 0 0 0 .002-1.232L5.38 2.097a.9.9 0 0 0-.652-.28"
        fill={color}
      />
    </svg>
  );
};
